export default __webpack_public_path__ + "static/media/img-1.682df50a.png";